export default {"src":"/_next/static/media/SaleCouponSvg.a8033812.svg","height":34,"width":35};